export default {
    loading(state, loading) {
        state.loading = loading;
    },
    setAccounts(state, accounts) {
        state.accounts = accounts
    }
}